import { render } from "./academiccandidatelist.vue?vue&type=template&id=77db1299"
import script from "./academiccandidatelist.vue?vue&type=script&lang=js"
export * from "./academiccandidatelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__